/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { InventoryRequestDTOFromJSON, InventoryRequestDTOToJSON, } from './InventoryRequestDTO';
/**
 * Check if a given object implements the DeleteInventoryRequestDTO interface.
 */
export function instanceOfDeleteInventoryRequestDTO(value) {
    return true;
}
export function DeleteInventoryRequestDTOFromJSON(json) {
    return DeleteInventoryRequestDTOFromJSONTyped(json, false);
}
export function DeleteInventoryRequestDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'selectAll': json['selectAll'] == null ? undefined : json['selectAll'],
        'inventoryIds': json['inventoryIds'] == null ? undefined : json['inventoryIds'],
        'filters': json['filters'] == null ? undefined : InventoryRequestDTOFromJSON(json['filters']),
        'excludeRecentlySold': json['excludeRecentlySold'] == null ? undefined : json['excludeRecentlySold'],
    };
}
export function DeleteInventoryRequestDTOToJSON(json) {
    return DeleteInventoryRequestDTOToJSONTyped(json, false);
}
export function DeleteInventoryRequestDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'selectAll': value['selectAll'],
        'inventoryIds': value['inventoryIds'],
        'filters': InventoryRequestDTOToJSON(value['filters']),
        'excludeRecentlySold': value['excludeRecentlySold'],
    };
}
